import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["props"];
export default function transformLinks(links) {
  return links.map(function (link) {
    var props = link.props,
        rest = _objectWithoutPropertiesLoose(link, _excluded);

    if (props) {
      return _extends({}, JSON.parse(props), rest);
    }

    return rest;
  });
}